import React, { useEffect, useRef, useState } from "react";
import BgComponent from "../Auth/Components/BgComponent";
import Logo from "../../assets/image/logo/logo.png";
import CustomFormLabel from "../../components/common/CustomFormLabel";
import RHFTextField from "../../components/controls/RHFTextField";
import { Link, useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import emailjs from "@emailjs/browser";
import { object, string } from "yup";
import { errorToaster, successToaster } from "../../util/toaster";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import MaskLoader from "../../components/MaskLoader";
import RHFTextarea from "../../components/controls/RHFTextarea";
import { emailServiceId, emailTemplateId, emailjsKey } from "../../shared/emailConfig";

const Contact = () => {
  const navigate = useNavigate();
  const emailRef = useRef();
  const nameRef = useRef();
  const messageRef = useRef();
  const [loading, setLoading] = useState(false);

  const [loader, setLoader] = useState(false);
  const schema = object({
    email: string()
      .email("Please enter valid email address")
      .required()
      .label("Email"),
    name: string().required().label("Name"),
    message: string().required().label("Message"),
  });

  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    document.title = "TRADEFOLIO - Contact US";
    setLoader(true);

    setTimeout(() => {
      setLoader(false);
    }, 5000);
  }, []);

  useEffect(() => emailjs.init(emailjsKey), []);
  const onSubmit = async ({ name, email, message }) => {
    setLoader(true);
    const serviceId = emailServiceId; //"service_plh6ktn";
    const templateId = emailTemplateId; //"template_1lkxlud"
    try {
      await emailjs.send(serviceId, templateId, {
        user_name: name,
        user_email: email,
        user_message: message,
      });
      successToaster("Message sent successfully.");
      setValue("name", "");
      setValue("email", "");
      setValue("message", "");
      setLoader(false);
      //navigate('/')
    } catch (error) {
      console.log(error);
      errorToaster(error);
      setLoader(false);
    }
  };

  return loader ? (
    <MaskLoader />
  ) : (
    <>
      <div className="flex flex-col min-h-[100vh] w-full">
        <div className="flex flex-row w-full h-[100vh] flex-1">
          <div className="lg:flex flex-[0.40] xs:hidden">
            <BgComponent bgImg="bg-login-bg" showBack={false}>
              <p className="text-white xl:text-[50px] lg:text-[40px] font-bold absolute bottom-40 xl:left-28 lg:left-16">
                Your Path to <br />
                Contact Us.
              </p>
            </BgComponent>
          </div>
          <div className="flex md:flex-[0.60] xs:flex-[0.80] flex-col lg:max-w-[550px] mx-auto xs:pt-[80px] md:pt-[40px] justify-center">
            <a href="/">
              <img src={Logo} className="relative xs:w-[120px] md:w-[170px]" />
            </a>
            <div className="xs:py-4 md:py-12 xl:px-0">
              <p className="xs:text-[22px] md:text-[35px] font-bold font-sans">
                Contact Us
              </p>
              <p className="text-[#7A86A1] text-xs md:text-sm"></p>
              <div className="grid grid-cols-1 lg:grid-cols-2 xs:gap-[10px] md:gap-5 xs:pt-[15px] md:pt-10">
                <div>
                  <CustomFormLabel htmlFor="email">Name</CustomFormLabel>
                  <RHFTextField
                    name="name"
                    id="name"
                    type="text"
                    placeholder="Tony Guyen"
                    //ref={nameRef}
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    // onChange={(e) => {
                    //     nameRef.current = e.target.value;
                    // }}
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                  />
                </div>
                <div>
                  <CustomFormLabel htmlFor="email">Your email</CustomFormLabel>
                  <RHFTextField
                    name="email"
                    id="email"
                    type="email"
                    placeholder="Tonynguyen@example.com"
                    //ref={emailRef}
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg "
                    // onChange={(e) => {
                    //     emailRef.current = e.target.value
                    // }}
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:pt-[10px] xs:mt-[12px]">
                <div>
                  <CustomFormLabel htmlFor="email">Message</CustomFormLabel>
                  <RHFTextarea
                    name="message"
                    id="message"
                    type="text"
                    placeholder="Write your message here..."
                    //ref={messageRef}
                    className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px] w-full text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg h-[100px]"
                    // onChange={(e) => {
                    //     messageRef.current = e.target.value;
                    // }}
                    isControlled={true}
                    control={control}
                    errorObj={errors}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:pt-[10px] xs:mt-[12px]">
                <div className="flex items-center justify-between">
                  <button
                    className="w-[120px] bg-[#0061FC] text-white  font-semibold xs:p-1 md:p-3 rounded-lg xs:text-[12] md:text-[14px]"
                    onClick={handleSubmit(onSubmit)}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-between py-[20px] md:px-20 xs:px-4  text-[#000000] w-full border-t-[1px]">
          <div className="opacity-50 text-[10px] font-sans">
            &copy;2023 TRADEFOLIO Inc. All Rights Reserved
          </div>
          <div className="opacity-50 text-[10px] font-sans  ">
            <Link to="/privacy">
              <u>Privacy Policy</u>
            </Link>{" "}
            /{" "}
            <Link to="/terms">
              <u>User agreement</u>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
